// extracted by mini-css-extract-plugin
export var dropdownButton = "_1r-0";
export var fullWidthDropdownButton = "_1r-1";
export var icon = "_1r-3";
export var iconPlaceholder = "_1r-2";
export var menuItemRow = "_1r-8";
export var separator = "_1r-c";
export var shortcutContainer = "_1r-7";
export var shortcutIconLg = "_1r-6";
export var shortcutIconMd = "_1r-5";
export var shortcutIconSm = "_1r-4";
export var submenuChevron = "_1r-b";
export var submenuDropdown = "_1r-9";
export var submenuTriggerRow = "_1r-a";